import React, { useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import {
  useApolloClient,
  useQuery,
} from "/lib/component/util";
import gql from "/vendor/graphql-tag";

const openQuery = gql`
  query SwitcherIsOpenQuery {
    modalStack @client
  }
`;

const closeQuery = gql`
  mutation CloseSwitcher {
    clearModal(modal: CREATE_TOTE_REP_MODAL) @client
  }
`;

export default function CreateToteReportDialog() {

  const client = useApolloClient();
  const queryResult = useQuery({ query: openQuery });
  const open = queryResult.data.modalStack.includes("CREATE_TOTE_REP_MODAL");

  const handleClose = useCallback(() => {
    client.mutate({ mutation: closeQuery });
  }, [client]);

  return (
    <Dialog open={open} onClose={handleClose} fullScreen>
      <DialogTitle>Tote Reporting</DialogTitle>
      <iframe title="hardwareCatalog" src="http://ec2-35-161-89-228.us-west-2.compute.amazonaws.com/" style={{ width: '100vw', height: '100vh' }} />
      <DialogActions>
        <Button onClick={handleClose} color="white">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
